// Set up the host to draw from
let host = ''

if (window.location.hostname === 'dev.uvic.ca') {
	host = 'https://' + window.location.hostname;
} else if (window.location.hostname === 'test.uvic.ca') {
	host = 'https://' + window.location.hostname;
} else if (window.location.hostname === 'localhost') {
	host = 'localhost';
} else {
	host = 'https://www.uvic.ca';
}

// Get the parameters from the URL
const getUrlParameter = (sParam, searchString) => {
	var searchString = searchString || window.location.search.substring(1);
	var sURLVariables = searchString.split('&');
	for (var i = 0; i < sURLVariables.length; i++) {
		var sParameterName = sURLVariables[i].split('=');
		if (sParameterName[0] == sParam) {
			return sParameterName[1];
		}
	}
	return null;
}

// Set default form state
const setupCalculator = () => {
	// Get elements
	const residencySelect = calculator.querySelector('#residency')
	const levelSelect = calculator.querySelector('#level')
	const programSelects = calculator.querySelectorAll('select[name="program"]')
	const submitButton = calculator.querySelector('button[type=submit]')
	// Get cookies
	const selfIdCookie = Cookies.get('uvic-selfIdWizard')
	// Get values
	let residency = getUrlParameter('residency') || getUrlParameter('residency', selfIdCookie)
	let level = getUrlParameter('level') || levelSelect.value
	let program = getUrlParameter('program')

	// Set the values of the select to the vars
	if (residency) residencySelect.value = residency
	if (level) levelSelect.value = level

	// Get the current program select, hide and disable the others
	let programSelect = calculator.querySelector(`[data-level="${level}"]`)
	let oldProgramSelect = false
	programSelects.forEach((prog) => {
		if (prog == programSelect) return

		prog.disabled = true
		prog.closest('.form-group').hidden = true
	})

	// Put the programs into the select element
	const populatePrograms = (programs) => {
		programSelect.classList.add('populating')
		programs.forEach((prog) => {
			programSelect.insertAdjacentHTML('beforeend', `<option value="${prog.id}">${prog.programName.replace(/-/g, '').trim()}</option>`)
			// programSelect.append($('<option/>', { value: program.id, text: program.programName.replace(/-/g, '').trim() }));
		});
		if (program) programSelect.value = program;
		programSelect.classList.remove('populating')
		// Enable the programs and level
		programSelect.disabled = false
		levelSelect.disabled = false
		if (level === 'LW') {
			programSelect.value = '9'
			submitButton.disabled = false
		}
	}

	// Load programs from a URL or a local test file
	const loadPrograms = async () => {
		// Set-up
		programSelect.classList.add('loading')
		let programs = []

		// Fetch programs from session storage if present
		if (sessionStorage) programs = JSON.parse(sessionStorage.getItem(`uvic-programs-${level}`))

		// If programs loaded from session storage, populate the select element
		if (programs) {
			// Send the programs to the program select element
			populatePrograms(programSelect, programs, program)
			programSelect.classList.remove('loading')
		} else {
			// set API url
			const url = host === 'localhost' ? `./data/tuition-programs-${level}.json` : `${host}/apis/program/getPrograms?level=${level}`

			// fetch the JSON
			const response = await fetch(url)

			// JSON didn't load, bail
			if (response.status !== 200) {
				return
			}

			// Get the programs data
			programs = JSON.parse(await response.text())
			// console.log(programs);

			// Send the programs to the program select element
			populatePrograms(programs)
			programSelect.classList.remove('loading')
		}
	}

	// Load progam values
	loadPrograms()

	// show/hide program select based on level
	levelSelect.addEventListener('change', () => {
		// Reset vars based on new level value
		level = levelSelect.value
		oldProgramSelect = programSelect
		programSelect = calculator.querySelector(`[data-level="${level}"]`)

		// Disable submit and program
		submitButton.disabled = true
		programSelect.closest('.form-group').hidden = false

		// hide old program select
		oldProgramSelect.disabled = true
		oldProgramSelect.closest('.form-group').hidden = true

		// Only load the programs to the select if it hasn't been loaded before: it's hidden and only contains a single, blank option
		if (!programSelect.hidden) {
			program = ''
			if (programSelect.querySelectorAll('option').length === 1) {
				levelSelect.disabled = true
				loadPrograms()
			} else {
				// Show and enable the programs
				programSelect.disabled = false
				if (level === 'LW') {
					programSelect.value = '9'
					submitButton.disabled = false
				}
			}
		}
	})

	// Toggle submit button based on if all three vars have a value
	submitButton.disabled = !(residency && level && program)

	// Toggle the submit button on program selection
	programSelects.forEach((prog) => {
		prog.addEventListener('change', () => {
			submitButton.disabled = !prog.value
		})
	})
}

const getResults = () => {
	// Get the values from the URL params
	const level = getUrlParameter('level')
	const residency = getUrlParameter('residency')
	const programId = getUrlParameter('program')
	const excludelist = ["4","17","21","102"]

	// Set the residency and level text based off the param values
	const resText = residency == "D" ? "Canadian student or permanent resident" : "International student";
	let levelText = ''
	switch (level) {
		case "UG":
			levelText = "Undergraduate"
			break
		case "GR":
			levelText = "Graduate"
			break
		case "LW":
			levelText = "Law"
			break
	}

	// Display the residency and level text
	document.querySelector('#residency').innerText = resText
	document.querySelector('#level').innerText = levelText

	// Update the "Change criteria" link to have the selected parameters so we can repopulate the form on the previous page.
	document.querySelectorAll('.js-change-criteria').forEach((link) => {
		if (residency != null || level != null || programId != null )
			link.href = `${link.href}?residency=${residency}&level=${level}&program=${programId}`
	})

	// Fetch program name
	const fetchProgram = async (id) => {
		// fetch the JSON
		const response = await fetch(`/apis/program/getProgram?id=${id}`)

		// JSON didn't load, bail
		if (response.status !== 200) {
			return
		}

		// Get the programs data
		const programData = JSON.parse(await response.text())

		document.querySelector("#program").innerText = programData.programName
	}
	if (host === 'localhost') {
		document.querySelector("#program").innerText = 'Business'
	} else {
		fetchProgram(programId)
	}

	// Get the fees table elements
	const feesTable = document.querySelector('#feesTable')
	const feesTableHead = feesTable.querySelector('thead')
	const feesTableBody = feesTable.querySelector('tbody')
	// Get the non-tuition fees table 
	const ancillaryFeesTable =  document.querySelector("#ancillaryFeesTable") || document.createElement('table')
	const ancillaryFeesTableHead = ancillaryFeesTable.querySelector('thead')  || document.createElement('thead')
	const ancillaryFeesTableBody = ancillaryFeesTable.querySelector('tbody')  || document.createElement('tbody')	

	// Get fee disclaimer
	const feesDisclaimer = document.querySelector('#feesDisclaimer')

	// Style the money values with commas
	const moneyStr = (num) => '$' + num.toString().replace(/(\d)(?=(\d{3})+$)/, '$1,')

	// Helper functions to update the DOM more efficiently.
	// Function to add rows to table
	const insertRows = (tableBody, rows) => {
		rows.forEach(row => tableBody.insertAdjacentHTML('beforeend', row));
	};
	// Function to set the table headers
	const setTableHeaders = (tableHead, headers) => {
		tableHead.innerHTML = ''; // Clear previous headers
		tableHead.insertAdjacentHTML('afterbegin', `<tr>${headers.map(header => `<th>${header}</th>`).join('')}</tr>`);
	};	

	// Fetch the tuition data
	const fetchFees = async () => {
		// Set the URL to fetch fees data
		let url = ''
		if (host === 'localhost') {
			if (level === "GR") {
				url = '/data/tuition-fees-grad.json';
			} else if (level === "LW") {
				url = '/data/tuition-fees-law.json';
			} else {
				// // adding International to test INT
				if (residency === "I") {
					url = '/data/tuition-fees-int.json';
				} else {
					url = '/data/tuition-fees.json';
				}
			}
		} else {
			if (level === "GR" || level === "LW") {
				url = `${host}/apis/fee/getFees?level=${level}&residency=${residency}&programId=${programId}`
			} else {
				url = `${host}/apis/fee/getGroupedFees?level=${level}&residency=${residency}&programId=${programId}`
			}
		}

		// fetch the JSON
		const response = await fetch(url)

		// JSON didn't load, bail
		if (response.status !== 200) {
			return
		}

		// Get the fees data
		const feesData = JSON.parse(await response.text())
		// console.log(feesData);

		// Clear table
		feesTable.querySelectorAll('tr').forEach((row) => row.remove())
		ancillaryFeesTable.querySelectorAll('tr').forEach((row) => row.remove())

		// Total vars
		let oneTermTotal = 0
		let twoTermTotal = 0
		let twoTermAncillaryTotal = 0

		// Write the fees data into the table 
		if (level === 'GR') {
			// Set the table header
			setTableHeaders(feesTableHead, ['Fee', 'One term']);

			// loop thru the feesData
			const rows = feesData.map(({ feeDescription, oneTermFee }) => {
                if (oneTermFee) {
                    oneTermTotal += oneTermFee;
                    return `<tr><td>${feeDescription}</td><td>${moneyStr(oneTermFee)}</td></tr>`;
                }
                return '';
            }).filter(row => row);

			// Add rows 
            insertRows(feesTableBody, rows);
            insertRows(feesTableBody, [`<tr><td>Total tuition estimate</td><td><strong>${moneyStr(oneTermTotal)}</strong></td></tr>`]);			
		} else if (level == 'LW') {
			// Set the table header
            setTableHeaders(feesTableHead, ['Fee', 'One term', 'Two term']);
			// delete <colgroup> for LAW because it contains 3 columns, not 2.
			feesTable.querySelectorAll("colgroup").forEach(colgroup => colgroup.remove())

            // loop thru the feedsData
            const rows = feesData.map(({ feeDescription, oneTermFee, twoTermFee }) => {
                if (oneTermFee && twoTermFee) {
                    oneTermTotal += oneTermFee;
                    twoTermTotal += twoTermFee;
                    return `<tr><td>${feeDescription}</td><td>${moneyStr(oneTermFee)}</td><td>${moneyStr(twoTermFee)}</td></tr>`;
                }
                return '';
            }).filter(row => row);

			// Add rows
            insertRows(feesTableBody, rows);
		} else {
			// For UG, show the non-tuition fees table and disclaimer
			ancillaryFeesTable.style.display = 'table';
			if (feesDisclaimer && residency === 'I' ) feesDisclaimer.style.display = 'block';

			// Set headers for both tables
			setTableHeaders(feesTableHead, ['Tuition fees', 'Two terms of study']);
			setTableHeaders(ancillaryFeesTableHead, ['Ancillary fees', 'Two terms of study']);

			// Insert tuition rows
			const tuitionRows = feesData['tuition'].map(({ feeDescription, twoTermFee }) => {
				if (twoTermFee) {
					twoTermTotal += twoTermFee;
					return `<tr><td>${feeDescription}</td><td>${moneyStr(twoTermFee)}</td></tr>`;
				}
				return '';
			}).filter(row => row);

			insertRows(feesTableBody, tuitionRows);

			// Insert ancillary (non-tuition) rows
			const ancillaryRows = feesData['ancillary'].map(({ feeDescription, twoTermFee }) => {
				if (twoTermFee) {
					twoTermAncillaryTotal += twoTermFee;
					return `<tr><td>${feeDescription}</td><td>${moneyStr(twoTermFee)}</td></tr>`;
				}
				return '';
			}).filter(row => row);

			insertRows(ancillaryFeesTableBody, ancillaryRows);

			// Insert total fees row
			if (feesData['tuition'].length > 1) {
				insertRows(feesTableBody, [`<tr><td>Total tuition fees</td><td><strong>${moneyStr(twoTermTotal)}</strong></td></tr>`]);
			}

			insertRows(ancillaryFeesTableBody, [`<tr><td>Total ancillary fees</td><td><strong>${moneyStr(twoTermAncillaryTotal)}</strong></td></tr>`]);
		}
	}

	if (excludelist.includes(programId)) {
		// pull information from block instead of API for these 
		const block = document.querySelector(`.te-${programId}-${residency.toLowerCase()}`)
		if (block) {
			block.classList.remove('d-none');
		}
	} 

	fetchFees()	
}

// Set-up the calculator or get the results
const calculator = document.querySelector('#tuition-calculator')
if (calculator) {
	// console.log('Set-up calculator');
	setupCalculator()
} else {
	// console.log('Show results');
	getResults()
}